import React from 'react';
import { translate } from "../../common/localization";

type GDPRProps = {
  text: string;
};

const GeneralDataProtectionRegulation: React.FC<GDPRProps> = ({ text }) => (
    <label dangerouslySetInnerHTML={{ __html: translate(text) }}></label>
);

export default GeneralDataProtectionRegulation;
